import './index.scss';

import { Component } from 'react';

import userRoles, { UserRoleValue } from '../../variables/user-roles';
import { BraxAvatar } from '../BraxAvatar';
import { BraxUncontrolledSelectField } from '../BraxUncontrolledForm';

export type BraxUserInfoProps<E extends boolean> = {
    avatar: string,
    avatarAlt: string
    name: string,
    email: string,
    userRole: UserRoleValue,
    editable: E,
    onChange?: E extends true ? (role: UserRoleValue) => void : never
};

export class BraxUserInfo<E extends boolean> extends Component<BraxUserInfoProps<E>> {

    static defaultProps = {
        editable: false
    };

    changeRole(role: UserRoleValue) {
        if (this.props.onChange)
            this.props.onChange(role);
    }

    render() {
        return (
            <div className="brax-user-info">
                <div>
                    <BraxAvatar src={this.props.avatar} alt={this.props.avatarAlt} />

                    <p>
                        <span>{ this.props.name }</span>

                        <span className="hint">{ this.props.email }</span>
                    </p>
                </div>

                { this.props.editable ? (
                    <BraxUncontrolledSelectField<UserRoleValue>
                        placeholder=""
                        value={this.props.userRole}
                        status="success"
                        variant="simple"
                        options={userRoles}
                        onChange={value => this.changeRole(value)}
                    />
                ) : null }
            </div>
        );
    }

}
